import React, { memo } from 'react'

const Logo = () => (
  <div className="logo">
    A Logo
  </div>
)

export default memo(Logo)
